import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getBetaStatus } from "../lib/api";

export default function HeaderBar({
  variant = "default",
  designName,
  rightSlot,
}) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [betaStatus, setBetaStatus] = useState(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    getBetaStatus()
      .then((r) => !cancelled && setBetaStatus(r.data))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [user]);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#1c1610]/85 border-b border-brass-900/40"
      data-testid="app-header"
    >
      <div className="flex items-center justify-between px-3 sm:px-6 py-3 sm:py-3.5 gap-2 sm:gap-0">
        <div className="flex items-center gap-3 sm:gap-6 min-w-0">
          <Link
            to={user ? "/dashboard" : "/"}
            className="flex items-center gap-2.5 group"
            data-testid="header-logo-link"
          >
            <img
              src="/logo-mark-80.png"
              alt="Blueprint AI"
              width={32}
              height={32}
              className="w-8 h-8 rounded-full ring-1 ring-brass-500/40 group-hover:ring-brass-400 transition-all"
              data-testid="header-logo-mark"
            />
            <span className="font-display text-lg tracking-tight text-zinc-50">
              BLUEPRINT<span className="text-brass-400">_</span>AI
            </span>
          </Link>
          {variant === "editor" && designName && (
            <div className="hidden md:flex items-center gap-3 pl-6 border-l border-zinc-800">
              <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                Project
              </span>
              <span
                className="font-display text-sm text-zinc-100"
                data-testid="header-design-name"
              >
                {designName}
              </span>
            </div>
          )}
        </div>

        <div className="flex items-center gap-3">
          {rightSlot}
          {user && betaStatus?.is_admin && (
            <button
              onClick={() => navigate("/admin")}
              className="hidden sm:inline-flex font-mono text-[10px] uppercase tracking-widest text-amber-400 hover:text-amber-200 transition-colors"
              data-testid="header-admin-link"
            >
              Admin
            </button>
          )}
          {user && variant !== "editor" && (
            <button
              onClick={() => navigate("/dashboard")}
              className="hidden sm:inline-flex font-mono text-[10px] uppercase tracking-widest text-zinc-400 hover:text-zinc-50 transition-colors"
              data-testid="header-projects-link"
            >
              My Projects
            </button>
          )}
          {user && (
            <div className="flex items-center gap-3 pl-3 border-l border-zinc-800">
              <Link
                to="/account"
                title="Account · ToS audit log"
                data-testid="header-account-link"
                className="block"
              >
                {user.picture ? (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="w-7 h-7 rounded-none border border-zinc-700 object-cover hover:border-brass-500 transition-colors"
                  />
                ) : (
                  <div className="w-7 h-7 border border-zinc-700 bg-zinc-800 grid place-items-center text-[10px] font-mono hover:border-brass-500 transition-colors">
                    {user.name?.[0] || "U"}
                  </div>
                )}
              </Link>
              <button
                onClick={logout}
                className="hidden sm:inline-flex font-mono text-[10px] uppercase tracking-widest text-zinc-500 hover:text-brass-400 transition-colors"
                data-testid="header-logout-btn"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
